import { PHONE, PHONE_LINK } from "@/constants/site";

const Footer = () => (
  <footer className="py-10 px-6 border-t border-white/10 bg-[#09070e] text-slate-500 text-xs font-mono" data-testid="footer">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <span className="text-white font-bold">chatblackhole.com</span>
        <span>&copy; 2025. 24/7 Virtual Products &amp; Academic Help.</span>
      </div>
      <div>
        Helpline:{" "}
        <a href={PHONE_LINK} className="hover:text-white transition-colors" data-testid="footer-phone-link">
          {PHONE}
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
